import styled from 'styled-components';
import { InformationName } from '../../CampaignDetails.styles';
import { ContentStylesProps } from './Content.interface';

export const StyledInformationName = styled(InformationName)`
    margin-top: ${({ theme }) => theme.spacing * 6}px;
`;

export const Image = styled.img<ContentStylesProps>`
    width: ${({ type }) => type === 'Poll' ? '176px' : '180px'};
    height: ${({ type }) => type === 'Poll' ? '99px' : '150px'};
    border-radius: 6px;
`;

export const ImageBig = styled.img`
    width: 100%;
    height: auto;
    border-radius: 6px;
`;

export const StyledLink = styled.p`
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
    font-size: 14px;
    line-height: 21px;
    text-decoration: none;
    margin: 0;
`;
